export default "__VITE_ASSET__0hu24qhO__"